import { readable } from "svelte/store"
import fontFaceObserver from "fontfaceobserver"

const fonts = ["Lora", "Open Sans", "Lexend"] as const

export const fontsReady = readable(false, (set) => {
    Promise.all(
        fonts.map((font) => {
            return new fontFaceObserver(font)
                .load(null, 8000)
                .then(() => [font, true] as const)
                .catch(() => [font, false] as const)
        }),
    ).then((res) => {
        if (res.some(([, loaded]) => !loaded)) {
            throw new Error(res.join(" | "))
        }
        set(true)
    })
})
